import {
  publishEvent,
  publishEventOnNextPage,
  registerComponent,
} from "helpers";

/*
  Publishes wyatt:view_item_list for the product list in its [data-item-list]
  payload when it connects, and wyatt:select_item when a product link inside
  one of its [data-item-list-position] cards is clicked or middle-clicked
  (contract in README.md, "Analytics events"). Filtering and sorting replace
  the whole section, so the replacement element connects and publishes the
  new results.
*/
registerComponent(
  "item-list-analytics",
  class ItemListAnalytics extends HTMLElement {
    connectedCallback() {
      this.payload = this.parsePayload();
      if (!this.payload) return;

      publishEvent("view_item_list", this.payload, "wyatt");

      this.addEventListener("click", this.handleClick);
      this.addEventListener("auxclick", this.handleClick);
    }

    // A list with nothing to report renders no payload.
    parsePayload() {
      const script = this.querySelector("[data-item-list]");
      return script ? JSON.parse(script.textContent) : null;
    }

    handleClick = (event) => {
      // auxclick also fires for the right button; only the middle one opens
      // the link.
      if (event.type === "auxclick" && event.button !== 1) return;

      const card = event.target
        .closest("a")
        ?.closest("[data-item-list-position]");
      if (!card) return;

      const position = Number(card.dataset.itemListPosition);
      const selectItem = {
        item_list_id: this.payload.item_list_id,
        item_list_name: this.payload.item_list_name,
        index: position,
        product: this.payload.resource.results[position],
      };

      // A middle or modified click opens the product in another tab or window
      // and this page stays, so the event publishes now; a plain click
      // navigates away.
      if (
        event.type === "auxclick" ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        publishEvent("select_item", selectItem, "wyatt");
      } else {
        publishEventOnNextPage("select_item", selectItem, "wyatt");
      }
    };
  },
);
